import logo from '@Resources/assets/logos/ike-logo-dark-small.png';
import Flex from '@Resources/styles/flex.scss';
import { AppBar, Button, Toolbar } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderStyles from '@Components/Header/Header.scss';
import Styles from './LoginView.scss';

const LoginHeader = (props) => {
    return (
        <div id="koru-header" className={HeaderStyles.hContainer}>
            <div
                className={cx(
                    HeaderStyles.hToolbar,
                    Flex.justifyCenter,
                    Flex.alignItemsCenter
                )}
            >
                <div className={Styles.headerIconContainer}>
                    <img src={logo} />
                </div>
            </div>
        </div>
    );
};

LoginHeader.propTypes = {};
export default LoginHeader;
